import React, { useState } from 'react';
import { ROUTES } from './constants';
import AgentManagement from './AgentManagement';



export default function Index() {
    const [page, setPage] = useState(ROUTES.DETAILS);


    switch (page) {
        case ROUTES.DETAILS:
            return <AgentManagement setPage={setPage} />

        default:
            return <AgentManagement setPage={setPage} />
    }


}

